<template>
  <div class="notice-container">官网公告</div>
</template>

<script>
export default {
  name: "notice",
  data() {
    return {};
  },
  created() {},
  watch: {},
};
</script>

<style lang="less" scoped>
.notice-container {
  min-height: calc(100vh - 60px - 360px);
}

@media (min-width: 992px) and (max-width: 1199px) {
}

@media (min-width: 768px) and (max-width: 991px) {
}

@media (max-width: 767px) {
}
</style>
